import type { Mutation } from 'vuex'
import type { SendCartDestinationSelectionErrors, State } from './state'
import type {
  DestinationDetail,
  DestinationDetailList,
} from '@/api/send_cart/model/sendCartModel'
import type { FolderTree, FolderTreeItem } from '@/api/model/folderModel'

import actionTypes from './actionTypes'
import { SendCartTypeEnum } from '@/api/send_cart/model/sendCartModel'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_SEND_CART_TYPE](state, type: SendCartTypeEnum): void {
    state.sendCartType = type
  },

  [actionTypes.SET_DESTINATION_DETAIL_LIST]: (
    state: State,
    list: DestinationDetailList
  ): void => {
    state.destinationDetailList = [...list]
  },

  [actionTypes.SET_CLIENT_LIST]: (state: State, list: DestinationDetailList): void => {
    state.clientList = [...list]
  },

  [actionTypes.SELECT_CLIENT]: (state: State, client: DestinationDetail): void => {
    state.selectedClient = { ...client }
  },

  [actionTypes.SET_RESPONSIBLE_PERSON_LIST]: (
    state: State,
    list: DestinationDetailList
  ): void => {
    state.responsiblePersonList = [...list]
  },

  [actionTypes.SELECT_RESPONSIBLE_PERSON]: (
    state: State,
    person: DestinationDetail
  ): void => {
    state.selectedResponsiblePerson = { ...person }
  },

  [actionTypes.SET_DESTINATION_FOLDER_TREE]: (
    state: State,
    folderTree: FolderTree
  ): void => {
    state.destinationFolderTree = [...folderTree]
  },

  [actionTypes.SELECT_DESTINATION_FOLDER]: (
    state: State,
    folder: FolderTreeItem
  ): void => {
    state.selectedFolder = { ...folder }
  },

  [actionTypes.SET_ERROR]: (
    state: State,
    errors: SendCartDestinationSelectionErrors
  ): void => {
    state.errors = { ...errors }
  },
}

export default mutations
